import { createAction } from 'redux-act';

export const apiRequestFailure = createAction('error/API_REQUEST_FAILURE');
export const clearErrors = createAction('error/CLEAR_ERRORS');
